import { createContext, useContext, useMemo, useState } from "react";
type MainContextType = {
  language: string;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
};

const MainContext = createContext<MainContextType | null>(null);

type Props = { children: JSX.Element };
export const LanguageContextProvider = ({ children }: Props) => {
  let url = new URL(window.location.href);

  const [language, setLanguage] = useState(
    url.search === ""
      ? navigator.language.toLocaleLowerCase().includes("pl")
        ? "PL"
        : "EN"
      : url?.search.includes("?lang=PL")
      ? "PL"
      : "EN"
  );
  console.log(
    url.search === ""
      ? navigator.language.toLocaleLowerCase().includes("pl")
        ? "PL"
        : "EN"
      : url?.search.includes("?lang=PL")
      ? "PL"
      : "EN",
    navigator.language
  );
  const [websiteTitle, setWebsiteTitle] = useState(
    url.search === ""
      ? navigator.language.toLocaleLowerCase().includes("pl")
        ? "Ocena gotowości do e-faktur (n-o-w.pl)"
        : "E-invoice readiness assessment (n-o-w.pl)"
      : url?.search === "?lang=PL"
      ? "Ocena gotowości do e-faktur (n-o-w.pl)"
      : "E-invoice readiness assessment (n-o-w.pl)"
  );
  document.title = websiteTitle;

  const mainContextMemoized = useMemo<MainContextType>(
    () => ({
      language,
      setLanguage,
    }),

    [language, setLanguage]
  );
  return (
    <MainContext.Provider value={mainContextMemoized}>
      {children}
    </MainContext.Provider>
  );
};

export const useLanguageContext = () => useContext(MainContext)!;
